import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { actions } from "../../../app/categoriesSlice";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { actions as actionsTypologies } from "../../../app/enumsSlice";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import { labelForFilterArchivieDoc } from "../../../utils/functions/filters";
import {
  useGetAdminCategoriesQuery,
  useGetAdminTypologiesQuery,
} from "../../api/admin/categoriesApi";

import { t } from "i18next";
import CoreSearchBar from "../../../app/core/components/CoreSearch/CoreSearch";
import { Tab, Tabs } from "@mui/material";
import { useGetCommercialistaQuery } from "../../api/admin/gestisciCommercialistiApi";
import {
  useDeleteAllDocumentsMutation,
  useGetDocumentsDataQuery,
  useReanalyzeAllDocumentMutation,
  useRejectAllDocumentMutation,
  useValidateAllDocumentMutation,
} from "../../api/admin/gestisciDocumentiApi";
import { useGetStudiosQuery } from "../../api/admin/gestisciStudioApi";
import { useGetUsersQuery } from "../../api/admin/gestisciUtentiApi";
import GestioneDocumentFilter from "./GestioneDocumentiTable/ControlCockpit/GestioneDocumentFilter";
import GestioneDocumentiButtonCockpit from "./GestioneDocumentiTable/ControlCockpit/GestioneDocumentiButtonCockpit";
import GestioneDocumentiStats from "./GestioneDocumentiTable/ControlCockpit/GestioneDocumentiStats";
import GestioneDocumentiTable from "./GestioneDocumentiTable/Table/GestioneDocumentiTable";
import documentManagementSlice from "./gestisciDocumentiSlice";

const GestioneDocumentiPage2 = () => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const location = useLocation();
  const initialState = location.state ? location?.state : "";
  const [selectedUser, setSelectedUser] = useState(initialState);
  const [isPolling, setIsPolling] = useState(false);
  const [pollingCounter, setPollingCounter] = useState(0);
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [debouncedInputOperatorValue, setDebouncedInputOperatorValue] =
    useState("");
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [filter, setFilter] = useState({
    mainCategoryId: "",
    subCategoryId: "",
    studioId: "",
    adminId: "",
    status: "",
    companyId: "",
    practiceId: "",
    dateFrom: "",
    dateTo: "",
    read: {},
    referenceYear: "",
  });
  const [additionalFilters, setAdditionalFilters] = useState({
    name: { filterType: "string", type: "contains", filter: "" },
  });

  const [orderDirection, setOrderDirection] = useState("desc");
  const [valueToOrderBy, setValueToOrderBy] = useState("createdAt");

  const [removeFilterCallback, setRemoveFilterCallback] = useState(null);

  // Hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 750);
    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  // Data from API
  const userFilter = !selectedUser ? "" : selectedUser.id;
  const { data, isLoading, isFetching, refetch } = useGetDocumentsDataQuery(
    {
      page,
      userFilter,
      filter,
      orderDirection,
      valueToOrderBy,
      additionalFilters,
      query: debouncedSearchTerm,
    },
    { refetchOnMountOrArgChange: true }
  );

  const {
    data: usersData,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useGetUsersQuery(
    {
      page: { startRow: 0, endRow: 10 },
      value: debouncedInputUserValue,
    },
    { refetchOnMountOrArgChange: true }
  );

  const { data: adminCategories } = useGetAdminCategoriesQuery();

  const { data: adminStudio } = useGetStudiosQuery({
    ...{ currentPage: 1, startRow: 0, endRow: 5 },
    value: debouncedInputStudioValue,
  });

  const {
    data: operatorsData,
    isFetching: isOperatorsFetching,
    isLoading: isOperatorsLoading,
  } = useGetCommercialistaQuery({
    page: { startRow: 0, endRow: 10 },
    value: debouncedInputOperatorValue,
  });

  const { data: adminTypologies } = useGetAdminTypologiesQuery();

  const [deleteAllDocuments, { isLoading: isDeleteLoading }] =
    useDeleteAllDocumentsMutation();
  const [validateAllDocument, { isLoading: isValidateAllDocumentLoading }] =
    useValidateAllDocumentMutation();
  const [rejectAllDocument, { isLoading: isRejectAllDocumentLoading }] =
    useRejectAllDocumentMutation();
  const [reanalyzeAllDocument, { isLoading: isReanalyzeAllDocumentLoading }] =
    useReanalyzeAllDocumentMutation();

  useEffect(() => {
    if (Object.keys(filter.read).length !== 0) {
      setAdditionalFilters((prev) => ({
        ...prev,
        read: filter.read,
      }));
    } else {
      setAdditionalFilters({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    if (adminCategories?.Data)
      dispatch(actions.setMacroCategories(adminCategories?.Data));

    if (adminTypologies?.Data)
      dispatch(actionsTypologies.setIdentTypologies(adminTypologies?.Data));
  }, [adminCategories, adminTypologies, dispatch]);

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) {
        newFilter[k] = "";
        if (k === "dateTo") newFilter["dateFrom"] = "";
      }
    });
    setFilter(newFilter);
    dispatch(documentManagementSlice.actions.setTableFilters(newFilter));

    if (removeFilterCallback) {
      removeFilterCallback(f);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIsPolling(true);
      if (pollingCounter < 8) {
        refetch();
        setPollingCounter((prevCounter) => prevCounter + 1);
      } else {
        setIsPolling(false);
        clearInterval(interval);
      }
    }, 3000);
    return () => {
      clearInterval(interval);
    };
  }, [refetch, pollingCounter]);

  return (
    <>
      {isLoading ? (
        <CoreSpinner />
      ) : (
        <div className="flex flex-col">
          <div className="flex items-center">
            <h2 style={{ width: "200px" }}>{t("Archive")}</h2>
            {appConfig?.modules?.documents?.folders && (
              <Tabs value={0}>
                <Tab
                  className="text-mont text-capitalize fs-6"
                  label={"Tabella"}
                />
                <Tab
                  className="text-mont text-capitalize fs-6"
                  label={"Cartelle"}
                  onClick={() => navigate("folder")}
                />
              </Tabs>
            )}
          </div>

          <div>
            <div className="flex flex-row -mt-16 justify-end space-x-2">
              {selectedUser?.id && (
                <CoreChip
                  label={
                    t("User") +
                    ": " +
                    selectedUser?.name +
                    " " +
                    selectedUser.surname
                  }
                  variant="outlined"
                  onDelete={() => setSelectedUser()}
                />
              )}
              {Object.entries(filter).map(
                ([k, v]) =>
                  k !== "dateFrom" &&
                  k !== "name" &&
                  v &&
                  (typeof v !== "object" || Object.keys(v).length !== 0) && (
                    <CoreChip
                      key={v}
                      label={labelForFilterArchivieDoc(
                        k,
                        v,
                        adminStudio,
                        operatorsData
                      )}
                      variant="outlined"
                      onDelete={() => handleRemoveFilter(v)}
                    />
                  )
              )}
              <GestioneDocumentFilter
                filter={filter}
                setFilter={setFilter}
                selectedUser={selectedUser}
                setSelectedUser={setSelectedUser}
                userList={usersData?.Data?.items}
                setDebouncedInputUserValue={setDebouncedInputUserValue}
                isUsersLoading={isUsersLoading || isUsersFetching}
                setPage={setPage}
                studios={adminStudio}
                setDebouncedInputStudioValue={setDebouncedInputStudioValue}
                operators={operatorsData}
                isOperatorsLoading={isOperatorsFetching || isOperatorsLoading}
                setDebouncedInputOperatorValue={setDebouncedInputOperatorValue}
                setRemoveFilterCallback={setRemoveFilterCallback}
              />
              {/* FIlter component */}
            </div>

            <div className="w-full flex items-center justify-between mt-5">
              <div style={{ flex: 3 }}>
                <CoreSearchBar
                  isLoading={!isPolling && (isLoading || isFetching)}
                  placeholder={t("SearchDocExt")}
                  searchTerm={searchTerm}
                  handleChange={setSearchTerm}
                />
              </div>
              <div style={{ flex: 5, marginRight: 6 }}>
                <GestioneDocumentiButtonCockpit
                  data={data?.Data?.items}
                  refetch={refetch}
                  isDeleteLoading={isDeleteLoading}
                  selectedUser={selectedUser}
                  deleteDocuments={deleteAllDocuments}
                  validateAllDocument={validateAllDocument}
                  rejectAllDocument={rejectAllDocument}
                  reanalyzeAllDocument={reanalyzeAllDocument}
                />
              </div>

              <GestioneDocumentiStats
                data={data?.Data}
                isPolling={isPolling}
                pollingCounter={pollingCounter}
              />
            </div>

            <GestioneDocumentiTable
              page={page}
              setPage={setPage}
              data={data?.Data}
              valueToOrderBy={valueToOrderBy}
              setValueToOrderBy={setValueToOrderBy}
              orderDirection={orderDirection}
              setOrderDirection={setOrderDirection}
              refetch={refetch}
              isLoading={
                isLoading ||
                isDeleteLoading ||
                isRejectAllDocumentLoading ||
                isValidateAllDocumentLoading ||
                isReanalyzeAllDocumentLoading
              }
              totalPages={Math.ceil(data?.Data?.count / TABLE_ROWS_NUMBER) || 1}
              isFetching={isFetching}
              isPolling={isPolling}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default GestioneDocumentiPage2;
